import { Checkbox } from "@mui/material";
import ImgBackgroundModal from "../../../../../common/components/ImgBackgroundModal";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const modalContentsArray: { heading: string; mainDiv: JSX.Element }[] = [
  {
    heading: "Fill the Property Purchase Request Form & Preview your Invoice",
    mainDiv: (
      <>
        <div className="mb-[5px]">
          Provide your basic information and preferences for the property and
          review the full breakdown of your payment obligations and terms. The
          invoice will include a breakdown of payment comprising of the
          following components:
        </div>
        <ul className="list-[circle] pl-5 space-y-[5px]">
          <li>Property amount</li>
          <li>Letter of comfort fee (0.5%)</li>
        </ul>
      </>
    ),
  },
  {
    heading: "Create a First Bank Account",
    mainDiv: (
      <div>
        You’ll be required to open an account to complete your purchase.
      </div>
    ),
  },
  {
    heading: "Make Your Payment",
    mainDiv: (
      <div>Proceed with the payment via your desired channel.</div>
    ),
  },
  {
    heading: "Confirm Property Documents",
    mainDiv: (
      <div>
        Upon payment, we’ll share your property documents (Sales Receipt, Letter
        of Allotment(House), Letter of Allocation(Land)) for your confirmation
      </div>
    ),
  },
  {
    heading: "Authorization Letter",
    mainDiv: (
      <div>
        Upon Approval, First bank is notified that customer has approved the
        documents.
      </div>
    ),
  },
  {
    heading: "Delivery of Property Documents",
    mainDiv: (
      <div>
        Hard copies of all the official documents to the Property will be
        sent to (Customers Address) via DHL
      </div>
    ),
  },
];

const ModalBoxes = ({
  index,
  heading,
  mainDiv,
}: {
  index: number;
  heading: string;
  mainDiv: JSX.Element;
}) => (
  <div className="grid gap-[10px] [grid-template-columns:25px_auto]">
    <div className="flex justify-center items-center rounded-[50%] bg-[#066D0E] text-[#FFFFFF] text-[16px] w-[25px] h-[25px]">
      {index}
    </div>
    <div className="flex items-center text-[#066D0E] text-[16px]">
      {heading}
    </div>
    <div></div>
    <div className="text-[13px] text-[#363636] font-light">{mainDiv}</div>
  </div>
);

const WhatToExpectModal = ({
  show = false,
  setShow,
  btnActtion,
}: {
  show?: boolean;
  setShow: (value: boolean) => void;
  btnActtion: () => void;
}) => {
  const [acceptTerms, setAccepTerms] = useState(false);

  return (
    <ImgBackgroundModal
      showModal={show}
      headerText="Here’s what to expect next"
      subTextDiv={
        <div className="flex gap-x-[15px] mt-[5px] mb-[5px]">
          <Checkbox
            id="terms"
            name="terms"
            // value={inputs.terms}
            onChange={() => setAccepTerms((currentState) => !currentState)}
            color="primary"
            // checked={isItemSelected}
          />
          <label
            htmlFor="terms"
            className="font-light text-[#363636] text-[13px]"
            style={{ marginBottom: 0 }}
          >
            I have reviewed and agreed to the{" "}
            <a
              href={`${process.env.REACT_APP_FE_BASEURL}/terms-and-conditions`}
              className="text-[#066D0E] underline hover:no-underline"
            >
              Terms and Conditions
            </a>{" "}
            of sale and I consent to the{" "}
            <Link
              to={`/data-consent`}
              className="text-[#066D0E] underline hover:no-underline"
            >
              Data Use Policy
            </Link>
            .
          </label>
        </div>
      }
      additionalInfoDiv={
        <div className="text-[#363636] font-light pt-[10px]">
          For more information or enquiries reach out to us on{" "}
          <a
            href="#fff"
            className="text-[#066D0E] underline hover:no-underline"
          >
            info@homeandabroad.ng
          </a>{" "}
          or{" "}
          <a
            href="#fff"
            className="text-[#066D0E] underline hover:no-underline"
          >
            call us on...
          </a>{" "}
        </div>
      }
      btnActtion={btnActtion}
      disabled={!acceptTerms}
      onCloseModal={() => setShow(false)}
    >
      <div>
        <div className="text-[16px] text-[#5E5E5E] font-light mb-[10px]">
          Congratulations! You’re just a few steps away from owning your new
          property on Home and Abroad. Below is a quick overview of the process
          that will guide you through a smoth and secure property acquisition
          journey.
        </div>
        <div className="p-[10px] flex flex-col gap-[14px]">
          {modalContentsArray.map((modalContent, index) => (
            <ModalBoxes
              key={index}
              index={index + 1}
              heading={modalContent.heading}
              mainDiv={modalContent.mainDiv}
            />
          ))}
        </div>
      </div>
    </ImgBackgroundModal>
  );
};

export default WhatToExpectModal;
